/* eslint-disable @typescript-eslint/no-var-requires */
import { ReactElement, useRef } from 'react';
import { useProductPdfActions, useProductPdfData } from '@client/product/hooks';
import { PDFForm } from './PDFForm';
import { Props } from './PDFFormContainer.types';
/* eslint-disable import/no-webpack-loader-syntax */
// @ts-ignore
import styles from '!!css-loader!sass-loader?{"sassOptions":{"outputStyle":"compressed"}}!../PDFContent/PDFStyles.scss';

const INVALID_PATH = '//use.typekit.net/dvi2otu.css';

export const PDFFormContainer = (props: Props): ReactElement => {
  const { product } = props;
  const PDFContentRef = useRef<HTMLDivElement | null>(null);
  const {
    printPdf,
    downloadPdf,
  } = useProductPdfActions();
  const {
    printPdf: printData,
    downloadPdf: downloadData,
  } = useProductPdfData();
  const isPrintInProgress = printData.wasStarted && printData.isLoading;
  const isDownloadInProgress = downloadData.wasStarted && downloadData.isLoading;

  const getPDFContent = () => `
        <html>
          <head>
            <meta charset='UTF-8'>
          </head>
          <body>
            <style>
             ${styles.toString().replace(INVALID_PATH, `https:${INVALID_PATH}`)}
            </style>
            ${(PDFContentRef.current && PDFContentRef.current.innerHTML) || ''}
          </body>
        </html>
      `;

  const printPDF = () => printPdf(product.sku, getPDFContent());
  const generatePDF = () => downloadPdf(product.sku, getPDFContent());

  return (
    <PDFForm
      {...props}
      printPDF={printPDF}
      generatePDF={generatePDF}
      PDFContentRef={PDFContentRef}
      isPrintInProgress={isPrintInProgress}
      isDownloadInProgress={isDownloadInProgress}
    />
  );
};
